import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
import skeletonStyles from "../skeleton.module.css";
import styles from "./tags.module.css";
export var Tags = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, _isPending = param.isPending, isPending = _isPending === void 0 ? false : _isPending, listStyleClassName = param.listStyleClassName, listItemClassName = param.listItemClassName, _isUpperCaseText = param.isUpperCaseText, isUpperCaseText = _isUpperCaseText === void 0 ? true : _isUpperCaseText;
    var _obj;
    return /*#__PURE__*/ _jsx("ul", {
        className: cx(styles.list, listStyleClassName || "", (_obj = {}, _define_property(_obj, skeletonStyles.base, isPending), _define_property(_obj, skeletonStyles.active, isPending), _define_property(_obj, styles.upperCase, isUpperCaseText), _obj)),
        children: items.map(function(param) {
            var label = param.label, value = param.value;
            var _obj;
            return /*#__PURE__*/ _jsx(Text, {
                element: "li",
                fontSizeFixed: "3xs",
                className: cx(styles.item, listItemClassName || "", (_obj = {}, _define_property(_obj, skeletonStyles.base, isPending), _define_property(_obj, skeletonStyles.active, isPending), _obj)),
                title: label,
                children: value
            }, label);
        })
    });
};
export default Tags;
